var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgLogoVitaInternationalLight = function SvgLogoVitaInternationalLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 38,
    viewBox: "0 0 165 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3 6.6 10 8h3.3L8.9.7H5.6L1 8h3.2L5 6.7zm-.8-1.4H6L7.2 3z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2 5q2.6-.4 2.6-2c0-1.6-1.8-2.3-4-2.3h-4.6V8h3V5l3 2.8h3.7zm-3-2.8h.3c1 0 2.1 0 2.1.9 0 .7-1 .8-2 .8h-.4z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 1 30.3.5q-2.6 0-4.5 1.1-1.6 1-1.7 2.6T26 7a9 9 0 0 0 4.3 1q1.3 0 2.7-.3V5.5q-1 .8-2.6.8-3-.1-3.1-2c0-1 1.2-2 3-2q1.7 0 2.7.8z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m42 6.6.8 1.3H46L41.6.7h-3.3L33.8 8h3.3l.8-1.3zm-.8-1.4h-2.5L39.9 3z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3.7H51L56 8h2.3l5-7.2h-3.4l-2.8 4.4z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64 .7V8h3V.7z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6 2.3h2.5V.7h-8v1.6h2.5V8h3z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m83.4 6.6.8 1.3h3.2L83 .7h-3.3L75.2 8h3.2l.8-1.3zm-.8-1.4h-2.5L81.3 3z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 14H.9q.3 1 .3 2.7v7.4q0 1.8-.3 2.8h2.8q-.3-1-.2-2.8zm-2.3-1.6v-1.9h2.3v1.9z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 24.1q0 1.8-.2 2.8h2.8q-.3-1-.3-2.8v-7.4q-.2-1.6 1.2-1.5h7.4q1.3-.1 1.1 1.5V24q0 1.8-.2 2.8h2.8q-.3-1-.3-2.8v-6.8c0-2.5-.8-3.3-3.3-3.3h-7.1l-.7.2-.7.7v-1H6l.2 2.8z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2 20v-3.3q-.1-1.6 1.2-1.5h7.5q1.4-.2 1.2 1.5V20zm12.2 1.2v-3.9c0-2.5-1-3.3-3.4-3.3h-7.7c-2.5 0-3.4.8-3.4 3.3v6.2c0 2.6.9 3.4 3.4 3.4H49l.3-1.5q-1 .3-2.8.2h-8.2q-1.4.1-1.2-1.4v-3z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4 14c-1.2 0-1.5.6-1.7 1.2l-.2-1.2h-2.3q.3 1 .3 2.7v7.4q0 1.8-.3 2.8H54q-.2-1-.2-2.8v-7q-.1-1.6 1.1-1.5h2c1.4 0 2.9.3 3.4.3l.1-2z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6 24.1q0 1.8-.2 2.8H64V16.6q-.1-1.6 1.2-1.5h7.4q1.3-.2 1.1 1.5V24q0 1.8-.2 2.8h2.8q-.3-1-.3-2.8v-6.8c0-2.5-.8-3.3-3.3-3.3h-7.1q-.4 0-.7.2l-.7.7v-1h-2.7l.2 2.8z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2 17.3c0-2.5-.9-3.3-3.4-3.3H78.5l-.2 1.5q1-.2 2.7-.2h7.7q1.4-.2 1.2 1.3v.2q.1 1.5-1.2 1.4h-7.3c-2.5 0-3.4.8-3.4 3.4v2c0 2.5 1 3.3 3.4 3.3h6.8l1.2-.1q.3-.1.5-.7l.3.8h2.2q-.2-1-.2-2.8zm-2.3 6.9q.1 1.5-1.2 1.4h-7.2q-1.3.1-1.2-1.4v-3.3c0-1.2.3-1.4 1.2-1.4H90z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.5 14H107l.2 2.7v7.4q0 1.8-.2 2.8h2.8q-.3-1-.3-2.8zm-2.3-1.6v-1.9h2.3v1.9z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.5 17.3c0-2.5-.9-3.3-3.4-3.3h-7.7c-2.5 0-3.4.8-3.4 3.3v6.2c0 2.6 1 3.4 3.4 3.4h7.7c2.5 0 3.4-.8 3.4-3.4zm-3.5-2q1.3-.2 1.2 1.4v7.5q.2 1.5-1.2 1.4h-7.5c-1 0-1.1-.3-1.1-1.4v-7.5q-.1-1.6 1.1-1.5z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M128.6 24.1q0 1.8-.2 2.8h2.7L131 24v-7.4q-.2-1.6 1.2-1.5h7.4q1.3-.2 1.1 1.5V24q0 1.8-.2 2.8h2.8q-.3-1-.3-2.8v-6.8c0-2.5-.8-3.3-3.3-3.3h-7.1l-.8.2-.6.7v-1h-2.8q.3 1.2.3 2.8z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.2 17.3c0-2.5-.9-3.3-3.4-3.3h-10.3l-.2 1.5q1-.2 2.7-.2h7.7q1.3-.2 1.2 1.3v.2q.2 1.5-1.2 1.4h-7.3c-2.5 0-3.4.8-3.4 3.4v2c0 2.5 1 3.3 3.4 3.3h6.8l1.2-.1q.3-.1.5-.7l.3.8h2.2q-.2-1-.2-2.8zm-2.3 6.9q.2 1.5-1.2 1.4h-7.2q-1.3.1-1.2-1.4v-3.3c0-1.2.3-1.4 1.2-1.4h8.4z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M161.8 10.6c.2.7.2.4.2 1.7V24q0 1.8-.2 2.8h2.8q-.3-1-.3-2.8V10.6z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33 15.2V14h-6.4v-3.5h-2.3V14h-2v1.2h2v8.3c0 2.6.8 3.4 3.3 3.4h5.9l.1-1.6q-.9.3-2.7.3h-3.1q-1.4.1-1.2-1.4v-9z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M104.8 15.2V14h-6.4v-3.5H96V14h-2v1.2h2v8.3c0 2.6.9 3.3 3.3 3.3h5.9l.1-1.5q-.9.3-2.7.3h-3.1q-1.3.1-1.2-1.4v-9z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M163.7 31.1v6.7h1v-6.7z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M146.5 31.1v6.7h4.6v-6.7z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M152.7 31.1v6.7h3v-6.7z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M157.2 31.1v6.7h2v-6.7z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M160.9 31.1v6.7h1.2v-6.7z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M138.7 31v6.8h6.2V31z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M129.3 31v6.8h7.8V31z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M118.4 31v6.8h9.3V31z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M105.8 31v6.8h11V31z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8 31v6.8h22.4V31z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M48 31v6.8h32.3V31z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M.8 31v6.8h45.5V31z",
    fill: "white"
  })));
};
var Memo = /*#__PURE__*/memo(SvgLogoVitaInternationalLight);
export default Memo;